<template>
  <div class="modern-select-box-container"
       tabindex="0"
       ref="dropdown"
       @keydown.space.prevent="isOpened = !isOpened"
       @keydown.enter.prevent="close"
       @keydown.up.left.prevent="previousValue"
       @keydown.down.right.prevent="nextValue"
  >
      <ModernInput
        tabindex="-1"
        type="hidden"
        :value="selectValue"
        :name="name"
        readonly
      />
    <ModernInput
      class="modern-select-box"
      tabindex="-1"
      :id="id"
      :value="selectLabel"
      readonly />
    <div @click="isOpened = !isOpened" class="click-handler"/>
    <transition name="fade">
      <div v-show="isOpened" class="modern-select-box-options">
        <div
          v-for="(value, idx) in options"
          @click="select(value)"
          @mouseenter="hoveredOptionsIdx = idx"
          :class="[{selected: hoveredOptionsIdx === idx}, 'modern-select-box__option']"
          :key="idx"
        >
          <slot name="optionContent" :option="value">
            {{ value[labelKey] }}
          </slot>
        </div>

        <slot name="options-footer"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import ModernInput from '@/components/ModernInput.vue';

export default {
  name: 'ModernSelectBox',
  components: { ModernInput },
  props: {
    name: null,
    id: null,
    value: {
      default: () => null,
    },
    options: {
      default: () => [],
      type: Array,
    },
    labelKey: {
      type: String,
      default: 'label',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
  },

  data() {
    return {
      selectValue: this.value,
      hoveredOptionsIdx: this.findIndex(this.value) || 0,
      isOpened: false,
    };
  },

  beforeDestroy() {
    document.body.removeEventListener('mousedown', this.clickOutsideListener);
    document.body.removeEventListener('wheel', this.clickOutsideListener, { assive: false });
  },

  computed: {
    selectLabel() {
      const found = this.findOption(this.value);
      return found ? found[this.labelKey] || found[this.valueKey] : null;
    },
  },

  watch: {
    isOpened(isOpen) {
      this.hoveredOptionsIdx = this.findIndex(this.value);
      if (isOpen) {
        document.body.addEventListener('mousedown', this.clickOutsideListener);
        document.body.addEventListener('wheel', this.wheelListener, { passive: false });
      } else {
        document.body.removeEventListener('mousedown', this.clickOutsideListener);
        document.body.removeEventListener('wheel', this.wheelListener, { passive: false });
      }
    },
  },

  methods: {
    close() {
      if (this.selectValue !== this.value) {
        this.$emit('input', this.selectValue);
      }
      this.isOpened = false;
    },

    clickOutsideListener(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        if (this.isOpened) {
          event.preventDefault();
          this.close();
        }
      }
    },

    wheelListener(event) {
      if (!event.target.closest('.modern-select-box-options')) {
        if (this.isOpened) {
          event.preventDefault();
          this.close();
        }
      } else {
        event.preventDefault();
      }
    },

    findOption(searchValue) {
      return this.options.find((value) => searchValue === value[this.valueKey]);
    },

    findIndex(searchValue) {
      return this.options.findIndex((value) => searchValue === value[this.valueKey]);
    },

    select(value) {
      this.selectValue = value[this.valueKey];
      this.$emit('input', value[this.valueKey]);
      this.close();
    },

    previousValue() {
      const selectedOptionIdx = this.findIndex(this.selectValue);
      if (selectedOptionIdx > 0) {
        const option = this.options[selectedOptionIdx - 1];
        if (!this.isOpened) {
          this.select(option);
        } else {
          this.selectValue = option[this.valueKey];
        }
      }
    },

    nextValue() {
      const selectedOptionIdx = this.findIndex(this.selectValue);
      if (selectedOptionIdx < this.options.length - 1) {
        const option = this.options[selectedOptionIdx + 1];
        if (!this.isOpened) {
          this.select(option);
        } else {
          this.selectValue = option[this.valueKey];
        }
      }
    },
  },

};
</script>

<style scoped lang="stylus">

</style>
